import { logger } from '@/lib/log'

const DAY_MS = 24 * 60 * 60 * 1_000

/** Milliseconds from `from` until the next occurrence of local `HH:MM`. */
export function msUntilLocalTime(hhmm: string, from: Date): number {
  const [hoursRaw, minutesRaw] = hhmm.split(':')
  const hours = Number.parseInt(hoursRaw ?? '', 10)
  const minutes = Number.parseInt(minutesRaw ?? '', 10)
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return DAY_MS

  const target = new Date(from)
  target.setHours(hours, minutes, 0, 0)
  let delta = target.getTime() - from.getTime()
  if (delta <= 0) delta += DAY_MS
  return delta
}

/**
 * A browser that renders video for months on end accumulates state no matter how
 * careful the app is. A reload at a quiet hour is the cheapest insurance against
 * slow leaks, and costs nothing when the screen is switched off at night.
 */
export function useNightlyReload(at: string | null) {
  let timer = 0

  function start(): void {
    if (at === null) return
    const delay = msUntilLocalTime(at, new Date())
    logger.info(`Nightly refresh scheduled in ${Math.round(delay / 60_000)} min (at ${at})`)
    timer = window.setTimeout(() => {
      logger.info('Nightly refresh — reloading')
      window.location.reload()
    }, delay)
  }

  function stop(): void {
    window.clearTimeout(timer)
  }

  return { start, stop }
}
